import React, { useState } from 'react';
import PropTypes from 'prop-types';

import DialogRoundedModal from '../../../../../../components/DialogRoundedModal';
import {
  SaveButton,
  CancelButton,
} from '../../../../../../components/Button/ActionButtons';
import InputLabel from '../../../../../../components/v2/InputLabel';
import { StyledRadioButtonGroup } from '../styles';

import texts from './texts.json';
import {
  SharedWorkoutEditType,
  sharedWorkoutEditOptions,
  buildSharedWorkoutMessage,
} from './utils';
import {
  SharedWorkoutMessage,
  NewWorkoutNameField,
  NewWorkoutNameInput,
} from './styles';

const SharedWorkoutDialog = ({
  usage,
  defaultWorkoutName,
  onConfirm,
  onCancel,
}) => {
  const [editOption, setEditOption] = useState(SharedWorkoutEditType.UPDATE_ALL);
  const [newWorkoutName, setNewWorkoutName] = useState(defaultWorkoutName);

  const isCreateNew = editOption === SharedWorkoutEditType.CREATE_NEW;

  return (
    <DialogRoundedModal
      title={texts.title}
      actionButtons={(
        <>
          <SaveButton
            onClick={() => onConfirm({ createNewWorkout: isCreateNew, newName: newWorkoutName })}
            disabled={isCreateNew && !newWorkoutName.trim()}
          >
            {texts.confirmButton}
          </SaveButton>
          <CancelButton onClick={onCancel}>
            {texts.cancelButton}
          </CancelButton>
        </>
      )}
      open
      onClose={onCancel}
    >
      <SharedWorkoutMessage>
        {buildSharedWorkoutMessage(usage)}
      </SharedWorkoutMessage>
      <StyledRadioButtonGroup
        options={sharedWorkoutEditOptions}
        onOptionChange={(value) => setEditOption(value)}
        selectedOption={editOption}
      />
      {isCreateNew && (
        <NewWorkoutNameField>
          <InputLabel>{texts.nameLabel}</InputLabel>
          <NewWorkoutNameInput
            value={newWorkoutName}
            onChange={(event) => setNewWorkoutName(event.target.value)}
          />
        </NewWorkoutNameField>
      )}
    </DialogRoundedModal>
  );
};

SharedWorkoutDialog.propTypes = {
  usage: PropTypes.shape({
    otherProgramCount: PropTypes.number,
    sameProgramOtherDayCount: PropTypes.number,
  }),
  defaultWorkoutName: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

SharedWorkoutDialog.defaultProps = {
  usage: null,
  defaultWorkoutName: '',
};

export default SharedWorkoutDialog;
